import React, { useState } from "react";
import { Calendar, X } from "lucide-react";
import bgImage from "../assets/images/afya9.jpeg";
import bgImage2 from "../assets/images/139637.jpg";
import event1 from "../assets/images/afya10.jpeg";
import event3 from "../assets/images/afya1.jpeg";
import event2 from "../assets/images/afya11.jpeg";

import upcom1 from "../assets/images/afya12.jpeg";
import upcom2 from "../assets/images/afya13.jpeg";
import upcom3 from "../assets/images/afya14.jpeg";
import upcom4 from "../assets/images/afya16.jpeg";

const events = [
  {
    id: 1,
    title: "Community Health Awareness Day – Dodoma",
    date: "November 22, 2025",
    image: upcom1,
    description:
      "Join our Dodoma team for a one-day health camp focusing on nutrition, family planning, and preventive care.",
    // button: "Register Now",
  },
  {
    id: 2,
    title: "Youth Future Campaign – Dodoma",
    date: "December 5, 2025",
    image: upcom2,
    description:
      "Help the youth disabled and needy to be healthy stable and achieve their dreams.",
    // button: "Join the Campaign",
  },
  {
    id: 3,
    title: "Mental Health Awareness Walk – Dar es Salaam",
    date: "December 12, 2025",
    image: upcom3,
    description:
      "Join our mental health awareness walk and help break the stigma around emotional well-being.",
    // button: "Sign Up",
  },
  {
    id: 4,
    title: "Marital Health Awareness Walk – Dar es Salaam",
    date: "December 12, 2025",
    image: upcom4,
    description:
      "Join our marital health awareness walk and support couples’ well-being through dialogue and care.",
    // button: "Sign Up",
  },
];

const pastEvents = [
  {
    id: 1,
    image: event1,
    caption: "First Fundraising Dinner Gala 2025 Dodoma Tanzania.",
  },
  {
    id: 2,
    image: event2,
    caption: "Providing Health Education at the University of Dodoma 2025.",
  },
  {
    id: 3,
    image: event3,
    caption: "Youth Empowerment Training – Morogoro 2024.",
  },
];

export default function EventsPage() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    participation: "Volunteer",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Format the payload for email
    const emailPayload = `
      Subject: ${formData.participation} Participation Request
      Name: ${formData.name}
      Email: ${formData.email}
      Message: ${formData.message}
    `;

    console.log("Email Payload:", emailPayload);
    alert(
      `Thank you for getting involved!\n\nYour participation type: ${formData.participation}`
    );

    // Reset form and close modal
    setShowModal(false);
    setFormData({ name: "", email: "", message: "", participation: "Volunteer" });
  };

  return (
    <div className="bg-secondary bg-opacity-10 text-gray-800 overflow-x-hidden">
      {/* HERO SECTION */}
      <section className="relative mt-16 flex flex-col justify-center items-center text-center bg-cover bg-center rounded-2xl overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-maroon-900/70 to-black/60 backdrop-blur-sm"></div>
        <div className="relative z-10 px-6">
          <h1 className="text-3xl md:text-4xl font-bold text-secondary mb-4 drop-shadow-lg">
            Empowering Communities Through Action
          </h1>
          <p className="font-light text-sm text-gray-600 mb-6">
            Join our upcoming activities and experience <em>ustawi kamili</em> —
            holistic well-being in motion.
          </p>
        </div>
      </section>

      {/* UPCOMING EVENTS */}
      <section className="py-16 px-6 md:px-16">
        <h2 className="text-2xl md:text-3xl font-bold mb-12">
          Upcoming Events
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {events.map((event) => (
            <div
              key={event.id}
              className="bg-white rounded-2xl shadow-sm hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <img
                src={event.image}
                alt={event.title}
                className="h-56 w-full object-cover rounded-t-2xl"
              />
              <div className="p-6">
                <div className="flex items-center text-sm text-gray-500 mb-2">
                  <Calendar className="w-4 h-4 mr-2 text-green-600" />
                  {event.date}
                </div>
                <h3 className="text-lg font-semibold mb-3 text-gray-800">
                  {event.title}
                </h3>
                <p className="text-gray-600 font-light text-sm mb-4">
                  {event.description}
                </p>
                {/* <button
                  onClick={() => setShowModal(true)}
                  className="bg-green-500 hover:bg-green-600 text-white px-5 py-2 rounded-full text-sm shadow-sm transition duration-300"
                >
                  {event.button}
                </button> */}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* FEATURED EVENT */}
      <section className="bg-green-50 py-12 px-6 md:px-16 flex flex-col md:flex-row items-center gap-10">
        <img
          src={bgImage}
          alt="Ustawi Kamili Week"
          className="rounded-2xl md:w-1/2 object-cover h-64"
        />
        <div className="md:w-1/2 animate-fadeInUp">
          <h2 className="text-3xl font-bold mb-4 text-green-900">
            Ustawi Kamili Week 2025
          </h2>
          <p className="text-gray-700 font-light mb-4 leading-relaxed">
            A week-long celebration of holistic well-being across Tanzania! Join
            workshops, health camps, and environmental activities that promote
            sustainable living and community resilience.
          </p>
          <div className="flex gap-4 flex-wrap">
            <button
              onClick={() => setShowModal(true)}
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-full transition-all duration-300 transform hover:scale-105"
            >
              Volunteer Now
            </button>
          </div>
        </div>
      </section>

      {/* PAST EVENTS */}
      <section className="py-16 px-6 md:px-16 bg-white">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          Our Past Events in Action
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {pastEvents.map((event) => (
            <div
              key={event.id}
              className="relative group rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300"
            >
              <img
                src={event.image}
                alt={event.caption}
                className="h-64 w-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent flex items-end p-4 opacity-90">
                <p className="text-white text-sm font-light">{event.caption}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section
        className="relative text-white py-20 px-6 md:px-16 text-center"
        style={{
          backgroundImage: `url(${bgImage2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/60 backdrop-blur-[2px]"></div>
        <div className="relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Be Part of the Change
          </h2>
          <p className="text-gray-100 text-sm md:text-base font-light max-w-2xl mx-auto mb-8">
            Volunteer, sponsor, or attend our next event — together we can
            achieve <em>ustawi kamili</em> across Tanzania.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <button
              onClick={() => setShowModal(true)}
              className="bg-secondary/80 hover:bg-secondary px-6 py-3 rounded-full shadow-md transition transform hover:scale-105"
            >
              Volunteer Now
            </button>
            <button
              onClick={() => setShowModal(true)}
              className="bg-white text-primary hover:bg-gray-100 px-6 py-3 rounded-full shadow-md transition transform hover:scale-105"
            >
              Sponsor an Event
            </button>
            
          </div>
        </div>
      </section>

      {/* MODAL */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-xl w-11/12 md:w-1/3 p-6 relative animate-fadeIn">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-3 right-3 text-gray-600 hover:text-red-500"
            >
              <X size={20} />
            </button>
            <h3 className="text-xl font-semibold text-center mb-4 text-green-800">
              Get Involved
            </h3>
            <form onSubmit={handleSubmit} className="flex flex-col gap-3">
              <select
                name="participation"
                value={formData.participation}
                onChange={handleChange}
                className="border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
              >
                <option value="Volunteer">Volunteer</option>
                <option value="Sponsor">Sponsor</option>
                <option value="Join Event">Join Event</option>
              </select>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
                required
                className="border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Your Email"
                required
                className="border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
              />
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Message"
                rows="3"
                required
                className="border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
              ></textarea>
              <button
                type="submit"
                className="bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg mt-2 transition-all"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
